import { render, staticRenderFns } from "./Dviewcha.vue?vue&type=template&id=8b86293a&scoped=true"
import script from "./Dviewcha.vue?vue&type=script&lang=js"
export * from "./Dviewcha.vue?vue&type=script&lang=js"
import style0 from "./Dviewcha.vue?vue&type=style&index=0&id=8b86293a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b86293a",
  null
  
)

export default component.exports